import React from 'react';
import PropTypes from 'prop-types';
import {Spin} from 'antd';
import {useSelector} from 'react-redux';
import {ReactComponent as Logo} from '../../../assets/images/logoMandiri.svg';
import './index.style.less';

const LoadingScreen = ({children}) => {
  const storeLoading = useSelector((state) => state.loadingScreen.isLoading);

  if (storeLoading) {
    document.onkeydown = function (e) {
      if (e.code === 'Enter') {
        e.preventDefault();
      }
    };
  } else {
    document.onkeydown = function () {
      setTimeout(() => {
        return true;
      }, 1000);
    };
  }

  return (
    <>
      <div className={storeLoading ? 'container-loading-screen' : ''}></div>
      {storeLoading ? (
        <>
          <div className='container-logo'>
            <Logo className='custom-logo' />
          </div>
          <Spin size='medium' className='custom-spinner' />
        </>
      ) : (
        ''
      )}
      <div>{children}</div>
    </>
  );
};

export default LoadingScreen;

LoadingScreen.propTypes = {
  children: PropTypes.node.isRequired,
};
